// extracted by mini-css-extract-plugin
module.exports = {"sharedBrace":"SharedBrace_sharedBrace__20tdI","sharedCircle":"SharedBrace_sharedCircle__bQKzj"};